import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EditDeviceNoteModalData {
    deviceId: string;
    note: string | null;
    name?: string;
    model?: string;
    osVersion?: string;
    operatingSystem?: string;
}

@Component({
    selector: 'myrtls-edit-device-note-modal',
    templateUrl: './edit-device-note-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EditDeviceNoteModalComponent {
    note: string;

    constructor(
        public dialogRef: MatDialogRef<EditDeviceNoteModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EditDeviceNoteModalData,
    ) {
        this.note = data.note ?? '';
    }

    save() {
        this.dialogRef.close(this.note.trim() || null);
    }

    cancel() {
        this.dialogRef.close(undefined);
    }
}
